import { Room, Track } from "livekit-client";
import { useCallback, useMemo } from "react";
import { useLocalScreenShare } from "@/hooks/livekit/useLocalScreenShare";

export function useLivekitScreenShare(room?: Room) {
  const localScreenShare = useLocalScreenShare();
  const { requestScreenShare } = localScreenShare;
  const startScreenShare = useCallback(async () => {
    if (!room) return;

    const alreadySharing = room.localParticipant.getTrackPublication(
      Track.Source.ScreenShare
    );
    if (alreadySharing) {
      console.warn(" قبلاً در حال اشتراک‌گذاری هستید.");
      return false;
    }

    const [screenTrack, systemAudioTrack] = await requestScreenShare();

    if (!screenTrack) {
      console.warn(" ترک screen share ایجاد نشد.");
      return false;
    }

    try {
      await room.localParticipant.publishTrack(screenTrack, {
        source: Track.Source.ScreenShare,
      });

      if (systemAudioTrack) {
        await room.localParticipant.publishTrack(systemAudioTrack, {
          source: Track.Source.ScreenShareAudio,
        });
      }
      return true;
    } catch (err) {
      console.error(" خطا در انتشار screen share:", err);
    }
  }, [room, requestScreenShare]);

  return useMemo(
    () => ({ startScreenShare, ...localScreenShare }) as const,
    [localScreenShare, startScreenShare]
  );
}
